import { Provider } from '@angular/core';

export const LOCAL_DEV_INTERCEPTORS: Provider[] = [];
